import { storeToRefs } from "pinia";
import { Encoding } from "@aeternity/aepp-sdk";
import { useNetworkStore } from "@/stores/network";
import { validateHash } from "@/utils/common";

const ADDRESS_TYPES: Record<string, string> = {
  [Encoding.AccountAddress]: "accounts",
  [Encoding.ContractAddress]: "contracts",
  [Encoding.Name]: "names",
  [Encoding.OracleAddress]: "oracles/queries",
  [Encoding.TxHash]: "transactions",
};

export function useAeScan() {
  const { activeNetwork } = storeToRefs(useNetworkStore());

  function getEndpointByHash(hash: string) {
    const { valid, prefix } = validateHash(hash);
    if (valid && prefix) {
      return ADDRESS_TYPES[prefix];
    }
    return undefined;
  }

  function prepareUrlForHash(
    hash: string,
    prefix?: string
  ): string | undefined {
    const endpoint = prefix ?? getEndpointByHash(hash);
    return endpoint
      ? `${activeNetwork.value.explorerUrl}/${endpoint}/${hash}`
      : undefined;
  }

  return {
    getEndpointByHash,
    prepareUrlForHash,
  };
}
